import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import TrackingActions from '../../actions/TrackingActions';
import { GenericModals } from '../../constants/AppConstants';
import Station from '../../records/Station';
import TicketOffice from '../../records/TicketOffice';
import Search from '../../records/Search';
import SeasonSearch from '../../records/SeasonSearch';

import OpeningHours from './OpeningHours';
import OpeningStatus from './OpeningStatus';
import StationFacilities from './StationFacilities';
import AddStation from './AddStation';
import BaseModal from '../general/BaseModal';


class StationFinderModal extends React.PureComponent {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onClose: PropTypes.func,
        onContinue: PropTypes.func,
        selectedStation: PropTypes.instanceOf(Station),
        ticketOffice: PropTypes.instanceOf(TicketOffice),
        loadingTicketOfficeDetails: PropTypes.bool,
        currentSearch: PropTypes.oneOfType([
            PropTypes.instanceOf(Search),
            PropTypes.instanceOf(SeasonSearch)
        ])
    };

    static defaultProps = {
        onClose: _.noop,
        onContinue: _.noop,
        selectedStation: null,
        ticketOffice: null,
        loadingTicketOfficeDetails: false
    };

    state = {
        activeAddButton: null,
    }

    handleAddButtonSelected = (selected) => {
        this.setState({
            activeAddButton: selected
        });
    }

    handleClose = () => {
        this.setState({
            activeAddButton: null
        });

        this.props.onClose();
    }

    handleUpdateJourney = () => {
        this.props.onContinue(this.state.activeAddButton, this.props.selectedStation);
        this.handleClose();
    }

    _getSelectedStationName() {
        const { selectedStation } = this.props;
        return selectedStation ? selectedStation.name : null;
    }

    _getModalProps() {
        return {
            show: this.props.show,
            className: 'grid-modal modal--sm stationFinder__modal',
            onClose: this.handleClose,
            onContinue: this.handleUpdateJourney,
            onOpen: () => {
                TrackingActions.genericModalOpen(GenericModals.STATION_FINDER);
            },
            titleText: this._getSelectedStationName(),
            closeText: 'button.text.cancel',
            continueText: 'button.text.apply',
            disableContinue: this.state.activeAddButton === null
        };
    }

    render () {
        const { selectedStation, ticketOffice, loadingTicketOfficeDetails } = this.props;
        const facilities = _.get(selectedStation, 'facilities');

        return (
            <BaseModal { ...this._getModalProps() } >
                <OpeningStatus loadingTicketOfficeDetails={ loadingTicketOfficeDetails }
                    ticketOffice={ ticketOffice } />
                <AddStation
                    activeAddButton={ this.state.activeAddButton }
                    onSelect={ this.handleAddButtonSelected }
                />
                { facilities && <StationFacilities facilities={ facilities } /> }
                <OpeningHours ticketOffice={ ticketOffice }
                    loadingTicketOfficeDetails={ loadingTicketOfficeDetails } />
            </BaseModal>
        );
    }
}

export default StationFinderModal;



// WEBPACK FOOTER //
// ./src/components/stationFinder/StationFinderModal.js